/**
 * Format API URL parameters
 * Given a set of parameters to be sent via the URL, formats them in a string with the appropriate
 * delimiters and returns that value
 * @param params: array of string parameters, each formatted with the property and value like
 * {k: key, v: value}
 * @returns {string} URL on success, {boolean} false if parameters unable to be parsed
 */
export default class FormatUrlParameters {
  static format(params) {
    let formattedUrlParameters = '';

    params.forEach((param, index) => {
      if (index === 0) {
        formattedUrlParameters += '?';
      } else {
        formattedUrlParameters += '&';
      }

      formattedUrlParameters += `${param.k}=${encodeURIComponent(param.v)}`;
    });

    if (formattedUrlParameters.length === 0) {
      formattedUrlParameters = false;
    }

    return formattedUrlParameters;
  }

  static formatUrlParametersObject(params) {
    let formattedUrlParameters = '';
    const urlParams = this.stripFalsyProps(params);
    Object.keys(urlParams).forEach((param, index) => {
      if (index === 0) {
        formattedUrlParameters += '?';
      } else {
        formattedUrlParameters += '&';
      }
      formattedUrlParameters += `${param}=${encodeURIComponent(urlParams[param])}`;
    });

    if (formattedUrlParameters.length === 0) {
      formattedUrlParameters = false;
    }

    return formattedUrlParameters;
  }

  static stripFalsyProps(obj) {
    const paramsObj = { ...obj || {} };
    if (obj) {
      Object.keys(obj).forEach((p) => {
        if (!obj[p]) delete paramsObj[p];
      });
    }

    return paramsObj;
  }

  static encodeURIObjectValues(toEncode = {}, restrictToType = false, preventDupEncode = false) {
    if (
      !toEncode
      || typeof toEncode !== 'object'
      || Object.keys(toEncode).length < 1
    ) return toEncode || {};

    const encodedObj = { ...toEncode };
    Object.keys(toEncode).forEach((k) => {
      let encodedValue = encodeURIComponent(toEncode[k]);

      if (preventDupEncode) {
        try {
          if (
            decodeURIComponent(toEncode[k]) !== decodeURIComponent(encodedValue)
          ) encodedValue = toEncode[k];
        } catch (error) {
          // string likely contained several garbled special
          // characters and was not already encoded
          // we can log it and continue on
          console.log(error);
        }
      }

      if (typeof toEncode[k] !== 'object') {
        if (
          restrictToType
          && typeof toEncode[k] === typeof restrictToType
        ) encodedObj[k] = encodedValue;
        else if (!restrictToType) encodedObj[k] = encodedValue;
      }
    });

    return encodedObj;
  }
}
